var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.18461C0 1.39383 0.662031 0.751953 1.47812 0.751953H18.5219C19.3383 0.751953 20 1.39383 20 2.18461V19.3195C20 20.1105 19.3383 20.752 18.5219 20.752H1.47812C0.662109 20.752 0 20.1106 0 19.3198V2.18437V2.18461Z",
    fill: "#0A66C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07742 17.4891V8.485H3.08461V17.4891H6.07773H6.07742ZM4.58164 7.25586C5.62508 7.25586 6.27469 6.56445 6.27469 5.70039C6.25516 4.81664 5.62508 4.14453 4.60148 4.14453C3.57719 4.14453 2.9082 4.81664 2.9082 5.70031C2.9082 6.56437 3.55758 7.25578 4.56203 7.25578H4.58141L4.58164 7.25586ZM7.73398 17.4891H10.7266V12.4613C10.7266 12.1926 10.7461 11.9231 10.8252 11.7312C11.0414 11.1933 11.5338 10.6365 12.3608 10.6365C13.4434 10.6365 13.8768 11.4621 13.8768 12.6727V17.4891H16.8693V12.3264C16.8693 9.56086 15.393 8.27391 13.4241 8.27391C11.8098 8.27391 11.1008 9.17617 10.7069 9.7907H10.7268V8.48531H7.73414C7.7732 9.33 7.73391 17.4894 7.73391 17.4894L7.73398 17.4891Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.58197169281594f982f1e1409415f0f8.svg";
export { ForwardRef as ReactComponent };